export default{
    mutations:{
       onJcdSelect(state,jcd){
            state.jcdId = jcd.value;
       },
       /*onDateValueChange(state,dateVal) {
            state.dateValue = dateVal.value;
       },*/
       onFastChooseChange(state,choose){
           state.fastChoose = choose.value;
           if( choose.value === 'ZDY'){
               state.dateValue = ''
           }
       },
        reset(state){
            state.jcxmId = null;
            state.jcxm=null;
            state.jcdId = null;
            state.fastChoose = 'THIS_MONTH';
            state.dateValue = '';
        }
    },
    state:{
        jcxmId: null,
        jcxm:null,
        jcdId: null,
        jcd:null,
        dateValue: '',
        fastChoose: 'THIS_MONTH',
    },
}
